import * as types from './types'
import globals from '@/plugins/globals.js'
import moment from 'moment-timezone'
import store from '@/store'

export function setRequestDevices(state) {
  // set the status of tool/device associated with the Service Request
  let found = null
  let serviceRequest = store.getters['serviceRequests/request']
  // default
  state.requestDevices = JSON.parse(JSON.stringify(state.cleanRequestDevice))
  // find the tool
  found = state.tools.find(x => x.serviceRequestId === serviceRequest.Id)
  if (found !== undefined && found !== null) {
    state.requestDevices.tool = {
      serviceRequestId: found.serviceRequestId,
      id: found.id,
      serialNumber: found.serialNumber,
      appLayerProtocol: found.appLayerProtocol,
      status: found.status
    }
  }
  // find the shop device
  found = state.shopDevices.find(x => parseInt(x.serialNumber) === parseInt(serviceRequest.Device.SerialNumber))
  if (found !== undefined && found !== null) {
    state.requestDevices.device = {
      serviceRequestId: serviceRequest.Id,
      serialNumber: found.serialNumber,
      status: 'connected'
    }
  }
  // Finally, get the pairing info for this Service Request
  store.dispatch('astechhub/getPairingInfo', serviceRequest.Id)
  // console.log('Set Request Devices', { serviceRequest: serviceRequest, tools: state.tools, devices: state.shopDevices, request: state.requestDevices })
}

export default {
  [types.SET_REQUESTDEVICES](state) {
    setRequestDevices(state)
  },
  [types.SET_TOOLS](state, data) {
    // set the tools
    state.tools = data
    state.tools.forEach(element => {
      element.elapsedTime = globals.elapsedTime(element.lastEditedTime, 'not used')
      element.connectedTo = null
      element.serviceRequestId = null
      element.tech = null
    })
  },
  [types.SET_CONNECTED_DEVICES](state, data) {
    // this is triggered when the asTech Hub getConnectedAstechs is invoked.
    //    - the results are processed into two arrays, consisting
    //      of tools and devices.
    let found = null
    state.shopDevices = []
    data.forEach(element => {
      element.isTool = false
      element.connectedTo = null
      element.serviceRequestId = null
      element.tech = null
      element.location = null
      element.status = 'connected'
      // Tools
      found = state.tools.find(x => x.serialNumber === parseInt(element.serialNumber))
      if (found !== undefined && found !== null) {
        element.isTool = true
        found.status = 'connected'
      }
      if (!element.isTool) {
        state.shopDevices.push(element)
      }
    })
    // now, we can determine if any are associated with the current Service Request.
    setRequestDevices(state)
  },
  [types.SET_HUB_DATA](state, data) {
    // this is triggered by the asTech Hub based upon various
    // tool/device events.
    let found = null
    let serviceRequest = store.getters['serviceRequests/request']
    if (data !== undefined && data !== null) {
      console.log('Set Hub Data', { data: data, requestDevices: state.requestDevices })
      switch (data.action) {
        case 'set':
          break
        case 'reset':
          break
        case 'pair':
          found = state.tools.find(x => x.serialNumber === data.sn2)
          if (found !== undefined && found !== null) {
            console.log('Pair: tool', found)
            found.status = 'paired'
            if (parseInt(state.requestDevices.tool.serialNumber) === data.sn2) {
              state.requestDevices.tool.status = 'paired'
            }
          }
          found = state.shopDevices.find(x => x.serialNumber === data.sn)
          if (found !== undefined && found !== null) {
            console.log('Pair: device', found)
            found.status = 'paired'
            if (parseInt(state.requestDevices.device.serialNumber) === data.sn) {
              state.requestDevices.device.status = 'paired'
            }
          }
          break
        case 'repair':
          break
        case 'unpair':
          found = state.tools.find(x => x.serialNumber === data.sn2)
          if (found !== undefined && found !== null) {
            console.log('Unpair: tool', found)
            found.status = 'connected'
            if (parseInt(state.requestDevices.tool.serialNumber) === data.sn2) {
              state.requestDevices.tool.status = 'connected'
            }
          }
          found = state.shopDevices.find(x => x.serialNumber === data.sn)
          if (found !== undefined && found !== null) {
            console.log('Unpair: device', found)
            found.status = 'connected'
            if (parseInt(state.requestDevices.device.serialNumber) === data.sn) {
              state.requestDevices.device.status = 'connected'
            }
          }
          break
        case 'connect':
          found = state.tools.find(x => x.serialNumber === data.sn)
          if (found !== undefined && found !== null) {
            console.log('Connect: tool', found)
            found.status = 'connected'
            if (state.requestDevices.tool.serialNumber === data.sn) {
              state.requestDevices.tool.status = 'connected'
            }
          }
          // possibly, switching asTech Shop Devices
          if (serviceRequest.Device.SerialNumber === data.sn) {
            console.log('Connect: device')
            state.requestDevices.device = {
              serviceRequestId: serviceRequest.Id,
              serialNumber: data.sn,
              status: 'connected'
            }
          }
          break
        case 'disconnect':
          found = state.tools.find(x => x.serialNumber === data.sn)
          if (found !== undefined && found !== null) {
            console.log('Disconnect: tool', found)
            found.status = 'disconnected'
            if (state.requestDevices.tool.serialNumber === data.sn) {
              state.requestDevices.tool.status = 'disconnected'
            }
          }
          found = state.shopDevices.find(x => x.serialNumber === data.sn)
          if (found !== undefined && found !== null) {
            console.log('Disconnect: device', found)
            found.status = 'disconnected'
            if (state.requestDevices.device.serialNumber === data.sn) {
              state.requestDevices.device.status = 'disconnected'
            }
          }
          break
        case 'stats':
          if (data.info === null) {
            state.hubData.device.stats = {
              isAvailable: false,
              v: 0,
              rtt: 0,
              rssi: '',
              rx: 0,
              tx: 0
            }
          } else {
            state.hubData.device.stats = data.info
          }
          break
        case 'clear':
          state.hubData = state.cleanHubData
          break
        case 'error':
          state.hubData.error = data.info
          break
      }
    }
  },
  [types.SET_SELECTED](state, data) {
    // this is called when a master tech selects
    // a request, tool, or tech within Dispatch.
    //    - this is to ready for associating these entities.
    if (data !== undefined && data !== null) {
      switch (data.type) {
        case 'request':
          state.selected.request = data.value
          break
        case 'tool':
          state.selected.tool = data.value
          break
        case 'tech':
          state.selected.tech = data.value
          break
      }
    }
  },
  [types.SET_STATUS](state, data) {
    // whenever the status of a Service Request changes,
    // we need to update that request within the list
    // of requests that were called from Monitor Info.
    // console.log('Setting Status', data)
    state.requests.forEach(request => {
      if (parseInt(request.workOrderId) === parseInt(data.id)) {
        request.statusId = data.statusId
        request.status = data.status
      }
    })
  },
  [types.SET_REQUEST](state, data) {
    // whenever the Service Request changes,
    // we need to update that request within the list
    // of requests that were called from Monitor Info.
    state.requests.forEach(request => {
      if (parseInt(request.workOrderId) === parseInt(data.workOrder)) {
        request.toolId = data.toolID
        request.toolName = data.tool
        request.userId = data.userID
        request.masterTech = data.user
        request.statusId = data.statusID
        request.status = data.status
      }
    })
  },
  [types.SET_TOOL](state, data) {
    // a tool was associated with a Service Request,
    // we need to update the tool with that info.
    state.tools.forEach(tool => {
      if (parseInt(tool.serviceRequestId) === parseInt(data.workOrder)) {
        tool.serviceRequestId = null
        tool.statusID = 1
        tool.lastEditedTime = new Date(moment().tz('US/Central').format('YYYY-MM-DD HH:mm:ss'))
        tool.elapsedTime = globals.elapsedTime(tool.lastEditedTime, 'not used')
      }
    })
    state.tools.forEach(tool => {
      if (parseInt(tool.id) === parseInt(data.toolID)) {
        tool.serviceRequestId = data.workOrder
        tool.statusID = 0
        tool.lastEditedTime = new Date(moment().tz('US/Central').format('YYYY-MM-DD HH:mm:ss'))
        tool.elapsedTime = globals.elapsedTime(tool.lastEditedTime, 'not used')
      }
    })
  },
  [types.SET_TOOL_STATUS](state, data) {
    // a tool's status was changed,
    // we need to update the tool with that info.
    state.tools.forEach(tool => {
      if (parseInt(tool.id) === parseInt(data.toolID)) {
        tool.statusID = data.statusID
        tool.lastEditedTime = new Date(moment().tz('US/Central').format('YYYY-MM-DD HH:mm:ss'))
        tool.elapsedTime = globals.elapsedTime(tool.lastEditedTime, 'awol')
      }
    })
  },
  [types.SET_TECH](state, data) {
    // a tech was associated with a Service Request,
    // we need to update the tech with that info.
    state.techs.forEach(tech => {
      if (parseInt(tech.serviceRequestId) === parseInt(data.workOrder)) {
        tech.serviceRequestId = null
        tech.statusID = 1
        tech.lastEditedTime = new Date(moment().tz('US/Central').format('YYYY-MM-DD HH:mm:ss'))
        tech.elapsedTime = globals.elapsedTime(tech.lastEditedTime, 'awol')
      }
    })
    state.techs.forEach(tech => {
      if (parseInt(tech.id) === parseInt(data.userID)) {
        tech.serviceRequestId = data.workOrder
        tech.statusID = 0
        tech.lastEditedTime = new Date(moment().tz('US/Central').format('YYYY-MM-DD HH:mm:ss'))
        tech.elapsedTime = globals.elapsedTime(tech.lastEditedTime, 'awol')
      }
    })
  },
  [types.SET_TECH_STATUS](state, data) {
    // a tech's status was changed,
    // we need to update the tech with that info.
    state.techs.forEach(tech => {
      if (parseInt(tech.id) === parseInt(data.techId)) {
        tech.statusID = data.statusId
        tech.lastEditedTime = new Date(moment().tz('US/Central').format('YYYY-MM-DD HH:mm:ss'))
        tech.elapsedTime = globals.elapsedTime(tech.lastEditedTime, 'awol')
      }
    })
  },
  [types.SET_PAIRING_INFO](state, data) {
    // we need to update the current Service Request
    // tool/device information with that info
    // we obtained from a call to API Services (getPairingInfo).
    if (data !== undefined && data !== null &&
      state.requestDevices !== undefined && state.requestDevices !== null) {
      let serviceRequest = store.getters['serviceRequests/request']
      if (parseInt(serviceRequest.Id) === parseInt(data.ServiceRequestId)) {
        state.requestDevices.device.serviceRequestId = data.ServiceRequestId
        state.requestDevices.device.serialNumber = data.ShopSerialNumber
        state.requestDevices.tool.serviceRequestId = data.ServiceRequestId
        state.requestDevices.tool.serialNumber = data.ToolSerialNumber
        state.requestDevices.tool.appLayerProtocol = data.AppLayerProtocol
        state.requestDevices.tool.status = 'paired'
        state.requestDevices.device.status = 'paired'
      }
    }
    console.log('Set Pair Info', { data: data, requestDevices: state.requestDevices })
  },
  [types.SET_INTERVAL](state, interval) {
    // this is for the interval for fetching the asTech device stats.
    state.statisticInterval = interval
  },
  [types.SET_HOST](state, is) {
    // this is to set the host for taking the lead in obtaining the Monitor Info.
    state.isHost = is
  },
  [types.SET_MONITOR_INFO](state, data) {
    // this is called every 30 seconds after the Monitor Info is fetched
    // from API Services.  It's used to refresh the Dispatch screen.
    // The host browser window/tab will broadcast this same information to
    // other open browser tabs/windows.
    state.requests = []
    state.techs = []
    // set the elapsed time (and additional fields)
    state.tools.forEach(tool => {
      tool.connectedTo = null
      tool.serviceRequestId = null
      tool.tech = ''
      tool.elapsedTime = globals.elapsedTime(tool.lastEditedTime, 'not used')
    })
    state.shopDevices.forEach(device => {
      device.connectedTo = null
      device.serviceRequestId = null
      device.tech = ''
      device.location = null
    })
    if (data !== undefined && data !== null) {
      // set techs, plus elapsed time
      state.techs = data.techs
      state.techs.forEach(element => {
        element.elapsedTime = globals.elapsedTime(element.lastEditedTime, 'awol')
        element.serviceRequestId = null
      })
      // Paired tools/devices (coming down from Monitor)...
      if (data.pairs !== null) {
        // set both tools and devices with Service Request Id
        if (data.pairs.length > 0) {
          data.pairs.forEach(element => {
            state.tools.forEach(tool => {
              if (parseInt(tool.serialNumber) === parseInt(element.hostSerialNumber)) {
                tool.connectedTo = parseInt(element.shopSerialNumber)
                tool.serviceRequestId = parseInt(element.serviceRequestId)
                tool.appLayerProtocol = parseInt(element.deviceProtocol)
              }
            })
            state.shopDevices.forEach(device => {
              if (parseInt(device.serialNumber) === parseInt(element.shopSerialNumber)) {
                device.connectedTo = parseInt(element.hostSerialNumber)
                device.serviceRequestId = parseInt(element.serviceRequestId)
              }
            })
          })
        }
      }
      // Tool Status (coming down from Monitor)...
      if (data.tools !== null) {
        // set tools with Status
        if (data.tools.length > 0) {
          data.tools.forEach(element => {
            state.tools.forEach(tool => {
              if (parseInt(tool.serialNumber) === parseInt(element.serialNumber)) {
                tool.statusID = element.statusID
                tool.elapsedTime = globals.elapsedTime(element.createdDate, 'awol')
              }
            })
          })
        }
      }
      // Service Requests (coming down from Monitor)...
      if (data.requests !== null) {
        // now, deal with the Service Requests
        state.requests = data.requests
        if (state.requests.length > 0) {
          state.requests.forEach(request => {
            // set defaults, including elapsed time
            request.elapsedTime = globals.elapsedTime(request.createdDate, '')
            request.toolName = null
            request.isChatting = false
            request.isChat = false
            request.isEditingStatus = false
            if (request.masterTech === null) {
              request.masterTech = ''
            }
            // associate request with tool and tool with tech
            state.tools.forEach(tool => {
              if (request.workOrderId === tool.serviceRequestId) {
                tool.tech = request.masterTech
                request.toolName = tool.friendlyName
              } else if (parseInt(request.toolId) === parseInt(tool.id)) {
                request.toolName = tool.friendlyName
                tool.serviceRequestId = request.workOrderId
              }
            })
            // associate device with location and tech
            state.shopDevices.forEach(device => {
              if (request.vin === device.vin || request.workOrderId === device.serviceRequestId) {
                device.location = request.location
                device.tech = request.masterTech
                if (device.vin === null || device.vin === '') {
                  device.vin = request.vin
                }
              }
            })
            // associate tech with request
            state.techs.forEach(tech => {
              if (request.userId === tech.id && (request.status === 'Scan in Progress')) {
                // console.log('Tech Request', { tech: tech, request: request })
                tech.serviceRequestId = request.workOrderId
              }
            })
          })
        }
      }
      // Finally, set the status of tool/device associated with the Service Request
      setRequestDevices(state)
    }
  },
  [types.RESET_SERVICE_REQUEST](state) {
    // reset the Service Request
    state.serviceRequest = state.cleanServiceRequest
  },
  [types.SET_SERVICE_REQUEST](state, data) {
    // set the Service Request
    state.serviceRequest = state.cleanServiceRequest
    if (data !== undefined && data !== null) {
      if (data.length > 0) {
        state.serviceRequest = data[0]
      }
    }
  },
  [types.SET_CHAT_STATUS](state, status) {
    // set the Chat status (on Dispatch)
    if (state.requests.length > 0) {
      state.requests.forEach(request => {
        if (parseInt(request.workOrderId) === parseInt(status.id)) {
          request.isChatting = false
          request.isChat = false
          if (status.from === 'tech') {
            request.isChatting = true
          } else if (status.from === 'shop') {
            if (request.status === 'Waiting on Shop' || request.status === 'Submitted') {
              request.isChat = true
            }
          }
        }
      })
    }
  },
  [types.SET_WAIT_TIME](state, data) {
    state.waitTime = '< 1 min'
    if (data !== undefined && data !== null) {
      console.log('Wait Time', data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/astechhub/mutations.js